import { render, staticRenderFns } from "./EventButton.vue?vue&type=template&id=3a6ca7a2&"
import script from "./EventButton.vue?vue&type=script&lang=js&"
export * from "./EventButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports